import isEmpty from 'lodash/isEmpty'
import { isValidEmail } from 'utils/general/isValidEmail'
import { isValidUrlWithProtocol } from 'utils/general/isValidUrlWithProtocol'
import { isEmptyString } from 'utils/string/isEmptyString'
import { ProductCatalogueAccessType } from '../../../lambdas/insertCatalogueEntry/insertCatalogueEntrySchema'
import { isProductCatalogueAccessType, ProductBrandForm } from '../product-catalogue'

export type ValidationError = 'required' | 'invalid'

export type ValidatorFn = (data: ProductBrandForm) => ValidationError | undefined

export type Validators = {
  [Key in keyof ProductBrandForm]: ValidatorFn | undefined
} & {
  categoryIds?: ValidatorFn
}

export const isRequired = (fieldKey: keyof ProductBrandForm) => (data: ProductBrandForm) => {
  if (isEmpty(data[fieldKey])) return 'required'
}

export const isCategoryIdsValid: ValidatorFn = (data: ProductBrandForm) => {
  if (data.selectedProductBrand?.categoryIds.some((id) => !id)) return 'invalid'
}

export const customProductBrandId = 'custom-product-brand'

export const isRequiredForCustomProduct = (fieldKey: keyof ProductBrandForm) => (data: ProductBrandForm) => {
  if (data.selectedProductBrand?.id !== customProductBrandId) return undefined

  const value = data[fieldKey]
  if (isEmpty(value)) return 'required'
  if (typeof value === 'string' && isEmptyString(value)) return 'required'
}

export const isRequiredForUrlAccessTypes = (data: ProductBrandForm) => {
  const requiredUrlAccessTypes: ProductCatalogueAccessType[] = ['TICKET', 'DIRECT']
  if (data.accessType && isProductCatalogueAccessType(data.accessType) && requiredUrlAccessTypes.includes(data.accessType)) {
    if (isEmpty(data.accessUrl)) {
      return 'required'
    }
    if (!isValidUrlWithProtocol(data.accessUrl)) {
      return 'invalid'
    }
  }
}

export const requiredAccessApproverAccessTypes: ProductCatalogueAccessType[] = ['WORKFLOW']

export const isRequiredForAccessApproverAccessTypes = (data: ProductBrandForm) => {
  if (
    data.accessType &&
    isProductCatalogueAccessType(data.accessType) &&
    requiredAccessApproverAccessTypes.includes(data.accessType)
  ) {
    if (isEmpty(data.accessApprover)) {
      return 'required'
    }
  }

  if (data.accessType === 'EMAIL' && data.externalEmail && data.accessApprover) {
    return 'invalid'
  }
}

export const isRequiredForExternalEmail = (data: ProductBrandForm) => {
  if (data.accessType === 'EMAIL' && isEmpty(data.externalEmail) && isEmpty(data.accessApprover)) {
    return 'required'
  }

  if (data.accessType === 'EMAIL' && data.externalEmail && data.accessApprover) {
    return 'invalid'
  }

  if (data.accessType === 'EMAIL' && data.externalEmail && !isValidEmail(data.externalEmail)) {
    return 'invalid'
  }
}

export const isRequiredForWorkflowAccessType = (data: ProductBrandForm) => {
  if (data.accessType === 'WORKFLOW' && isEmpty(data.accessWorkflowId)) return 'required'
}
